import { Col } from 'antd';
import type { ColProps } from 'antd';

export interface DColProps extends ColProps {}

export const DarwinCol = (props: DColProps) => {
  return <Col {...props} />;
};
